module.exports = __webpack_public_path__ + "static/media/bubbles-icon.ab003a4a.svg";